// MUNYA OS · Select · sistema componentes ui/ v1
//
// Versión nativa para v1 (HTML <select>). El custom Select con keyboard nav
// queda para Año 2 si UX lo requiere. Mantiene paridad visual con Input.

import { forwardRef, useId, type SelectHTMLAttributes } from 'react';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  helperText?: string;
  errorMessage?: string;
  options: SelectOption[];
  placeholder?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { label, helperText, errorMessage, options, placeholder, id, className = '', ...rest },
  ref,
) {
  const autoId = useId();
  const selectId = id ?? autoId;
  const helperId = `${selectId}-helper`;
  const errorId = `${selectId}-error`;

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && (
        <label htmlFor={selectId} className="mn-label mb-0">
          {label}
        </label>
      )}
      {/* Envoltorio .mn-field como en Input, para que ambos midan lo mismo (40px).
          Cuando la fase 2 suba .mn-select a la altura del sistema, este componente
          debería quedarse en un <select className="mn-select"> pelado y recuperar el
          chevron de marca; hoy .mn-select mide 33px y volvería a descuadrar. */}
      <div
        className={['mn-field', errorMessage ? 'border-[var(--color-munya-destructive)]' : ''].join(
          ' ',
        )}
      >
        <select
          ref={ref}
          id={selectId}
          aria-invalid={errorMessage ? true : undefined}
          aria-describedby={errorMessage ? errorId : helperText ? helperId : undefined}
          className="flex-1 min-w-0 bg-transparent"
          {...rest}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value} disabled={opt.disabled}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      {errorMessage ? (
        <p id={errorId} role="alert" className="text-xs text-[var(--color-munya-destructive)]">
          {errorMessage}
        </p>
      ) : helperText ? (
        <p id={helperId} className="text-xs opacity-60">
          {helperText}
        </p>
      ) : null}
    </div>
  );
});
